import { render, staticRenderFns } from "./GalleryComponent.vue?vue&type=template&id=5c56ddf1&scoped=true&"
import script from "./GalleryComponent.vue?vue&type=script&lang=js&"
export * from "./GalleryComponent.vue?vue&type=script&lang=js&"
import style0 from "./GalleryComponent.vue?vue&type=style&index=0&id=5c56ddf1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c56ddf1",
  null
  
)

export default component.exports